"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const FormContext_1 = require("./FormContext");
function defaultChangeInterceptor(nextValues) {
    return nextValues;
}
const Form = (props) => {
    const { formRef, formApiRef, id, name, initialValues, initialErrors, onChange, onSubmit, onCancel, onReset, changeInterceptor = defaultChangeInterceptor, children, className, } = props;
    const [values, setValues] = (0, react_1.useState)(initialValues);
    const valuesRef = (0, react_1.useRef)(values);
    const [errors] = (0, react_1.useState)(initialErrors);
    const changeInterceptorRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(changeInterceptor);
    const onSubmitValues = (submittedValues) => {
        onSubmit && onSubmit(Object.assign({}, submittedValues));
    };
    const onSubmitHandler = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onSubmitValues(values);
    };
    const onResetHandler = onReset
        ? () => {
            onReset(setValues);
        }
        : undefined;
    const onChangeHandler = (nextValues) => {
        const prevValues = valuesRef.current;
        const nextInterceptedValues = changeInterceptorRef.current(nextValues, prevValues);
        setValues(nextInterceptedValues);
        valuesRef.current = nextInterceptedValues;
        if (formApiRef === null || formApiRef === void 0 ? void 0 : formApiRef.current) {
            formApiRef.current.values = nextInterceptedValues;
        }
        onChange && onChange(nextInterceptedValues);
    };
    if ((formApiRef === null || formApiRef === void 0 ? void 0 : formApiRef.current) === null) {
        formApiRef.current = {
            setValues,
            values,
            reset: onResetHandler,
            submit: onSubmitHandler,
        };
    }
    if ((formApiRef === null || formApiRef === void 0 ? void 0 : formApiRef.current) && onResetHandler) {
        formApiRef.current.reset = onResetHandler;
    }
    (0, react_1.useEffect)(() => {
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (formApiRef === null || formApiRef === void 0 ? void 0 : formApiRef.current)
                formApiRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("form", { "data-id": "form", ref: formRef, id: id || name || '', method: "POST", onSubmit: onSubmitHandler, className: className },
        react_1.default.createElement(FormContext_1.FormProvider, { value: {
                values,
                errors,
                onChange: onChangeHandler,
                onSubmit: onSubmitValues,
                onReset: onResetHandler,
                onCancel: onCancel !== null && onCancel !== void 0 ? onCancel : noop_1.default,
                setValues,
            } }, children)));
};
exports.default = Form;
//# sourceMappingURL=Form.js.map